<template>
  <tr>
    <td class="max-width-25">
      <router-link
        :to="{
          name: 'dashboard-company-detail',
          params: {
            documentNumber: company.document_number.replace(/[^\w\s]/gi, '')
          }
        }">
        {{ company.name }}
      </router-link>
    </td>
    <td>{{ company.document_number }}</td>
    <td class="text-center">
      <template v-if="company.phone">
        {{ company.phone | phone }}
      </template>
      <template v-else>-</template>
    </td>
    <td>{{ company.month_limit | brlPrice }}</td>
    <td class="text-center">{{ company.travelers > 0 ? company.travelers : '-'  }}</td>
    <td class="text-center">{{ company.orders > 0 ? company.orders : '-'  }}</td>
    <td>{{ company.creation_date | brDate }}</td>
  </tr>
</template>

<script>
 import phone from '@/filters/phone'

export default {
  filters: {
    phone
  },
  props: [
    'company'
  ]
};
</script>
